var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.14 22.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b5e24a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eventos_seleccionado",
    "data-name": "Eventos seleccionado"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.14,11.07c0-1.18-1.47-2.11-1.82-3.17-.36-1.1.28-2.72-.39-3.63-.67-.93-2.41-.82-3.34-1.49-.92-.67-1.35-2.36-2.45-2.71-1.06-.34-2.4.76-3.58.76S9.06-.28,7.99.07c-1.1.36-1.53,2.05-2.45,2.71-.93.67-2.66.57-3.34,1.49-.67.92-.03,2.53-.39,3.63-.35,1.06-1.82,1.99-1.82,3.17s1.47,2.11,1.82,3.17c.36,1.1-.28,2.72.39,3.63.67.93,2.41.82,3.34,1.49.92.67,1.35,2.36,2.45,2.71,1.06.35,2.4-.76,3.58-.76s2.51,1.1,3.58.76c1.1-.36,1.53-2.05,2.45-2.71.93-.67,2.66-.57,3.34-1.49.67-.92.03-2.53.39-3.63.35-1.06,1.82-1.99,1.82-3.17Zm-13.3,5.44l-4.13-3.76,1.5-1.65,2.39,2.17,5.62-6.89,1.73,1.41-7.11,8.71Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificacion);
export default __webpack_public_path__ + "static/media/verificacion.91403c1d7b95453a58689c60531f4191.svg";
export { ForwardRef as ReactComponent };